<template>
  <div class="card-form">
    <page-main
      ref="main"
      :table-data="table"
      :loading="loading"
      @submit="reload"
      :tablePage="page"
    >
      <page-header
        @genPurchase="genPurchase"
        slot="header"
        @submit="handleSubmit"
        ref="header"
      />
      <pagination
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        size="small"
        align="right"
        slot="pager"
        @change="handlePaginationChange"
      />
    </page-main>
  </div>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'

export default {
  name: 'resourceManagement-research-bizDemand',
  mixins: [EditLoading],
  components: {
    PageHeader: () => import('./components/header/index'),
    PageMain: () => import('./components/main'),
  },
  data() {
    return {
      table: [],
      loading: false,
      page: {
        curPage: 1,
        pageSize: 20,
        pageTotal: 0,
      },
    }
  },
  methods: {
    genPurchase() {
      this.$confirm(
        this.$l('tips_gen_purchase') || '是否生成采购单？',
        this.$l('INDEX.tips_question_title') || '提示',
        {
          confirmButtonText: this.$l('INDEX.tips_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.tips_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => {
          const tmpData = this.$refs.main.choiceData() || []
          const demandDetailCodeList = tmpData
            .filter((e) => e.resFabricDemandStatus == 'T')
            .map((e) => e.resFabricDemandDetailCode)
          if (!demandDetailCodeList || !demandDetailCodeList.length) {
            this.$message({
              showClose: true,
              message:
                this.$l('table_label_pl_select_add_data') ||
                '请选择需要生成采购单的记录',
              type: 'warning',
            })
            return
          }
          this.loadingOpen()
          this.$api
            .resFabricPurchaseGenerateApi({
              demandDetailCodeList,
            })
            .then((res) => {
              this.loadingClose()
              const { status, msg } = res
              if (status != 200) {
                this.$message({
                  showClose: true,
                  message: msg,
                  type: 'warning',
                })
              } else {
                this.$message({
                  showClose: true,
                  message: msg,
                  type: 'success',
                })
                this.reload()
              }
            })
            .catch(() => {
              this.loadingClose()
            })
        })
        .catch(() => {})
    },
    // 分页查询
    handlePaginationChange(val) {
      this.page = {
        curPage: val.current,
        pageSize: val.size,
        pageTotal: val.total,
      }
      this.$nextTick(() => {
        this.$refs.header.query()
      })
    },
    // 重载表格数据
    reload() {
      this.$refs.header.query()
    },
    // 加载表格数据
    handleSubmit(form) {
      this.loading = true
      this.$api
        .resFabricPurchaseListApi({
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.page.pageTotal = res.body.count
          this.table = res.body.data
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
}
</script>
